import React from "react";
import { View, StyleSheet, Image } from "react-native";
import NtSectionTitle from "../general/NtSectionTitle";
import NtSectionDescription from "../general/NtSectionDescription";
import NtMaterialIcon from "../../../components/NtMaterialIcon";
import NtText from "../../../components/NtText";
import colors from "../../../config/colors";
import NtMarketingSectionContainer from "../general/NtMarketingSectionContainer";
import { useMobile } from "../../../hooks/useMobile";

function NtGuestAppSection({}) {
  const isMobile = useMobile();

  const renderRow = (icon, text, containerStyle) => {
    return (
      <View
        style={[
          {
            flexDirection: "row",
            alignItems: "center",
            backgroundColor: "white",
            padding: 18,
            borderRadius: 10,
          },
          containerStyle,
        ]}
      >
        <View
          style={{
            backgroundColor: "#dfdfdf",
            borderRadius: 20,
            padding: 8,
            alignItems: "center",
            justifyContent: "center",
          }}
        >
          <NtMaterialIcon name={icon} color={colors.almostBlack} />
        </View>

        <NtText
          style={{
            marginLeft: 6,
            fontSize: 12,
            fontWeight: "500",
            color: colors.almostBlack,
          }}
        >
          {text}
        </NtText>
      </View>
    );
  };
  return (
    <NtMarketingSectionContainer
      style={styles.container}
      backgroundImage={require("../../../assets/images/marketing/d1b3daee02ae66fda79f82dccf85c41d246c43bb.png")}
    >
      <View
        style={{
          width: "100%",
          flexDirection: "row",
          alignItems: "center",
          flex: 1,
        }}
      >
        {/* left side */}
        <View
          style={{ flex: isMobile ? 1 : 2, paddingLeft: 15, paddingRight: 15 }}
        >
          <NtSectionTitle style={{ textAlign: "left", fontSize: 28 }}>
            GUEST APP
          </NtSectionTitle>
          <NtSectionDescription>
            It Allows Passengers to Stay Connected During their Cruise Vacation
          </NtSectionDescription>
          <View
            style={{
              flexDirection: isMobile ? "column" : "row",
              marginTop: 30,
            }}
          >
            {renderRow(
              "wallet-travel",
              "Your passengers connect to Ship WiFi",
              {
                flex: 1,
                marginRight: isMobile ? 0 : 10,
              }
            )}
            {renderRow("cellphone", "Passengers use their own device", {
              flex: 1,
              marginTop: isMobile ? 10 : 0,
            })}
          </View>
          <View
            style={{
              flexDirection: isMobile ? "column" : "row",
              marginTop: 10,
            }}
          >
            {renderRow("cog", "Ingegration w/ Passenger Management Systems", {
              flex: 1,
              marginRight: isMobile ? 0 : 10,
            })}
            {renderRow("puzzle", "Ingegration with current app", {
              flex: 1,
              marginTop: isMobile ? 10 : 0,
            })}
          </View>
        </View>

        {/* right side */}
        {!isMobile && (
          <View style={{ flex: 1, alignItems: "center" }}>
            <Image
              style={[
                {
                  width: 150,
                  height: 300,
                  resizeMode: "contain",
                },
              ]}
              source={require("../../../assets/images/marketing/7afffde683a9bd23580f12ed3b03d5a71d7a944e.png")}
            />
          </View>
        )}
      </View>
    </NtMarketingSectionContainer>
  );
}

const styles = StyleSheet.create({
  container: {
    alignItems: "center",
    height: 650,
  },
});

export default NtGuestAppSection;
